import React from "react";
import { useSelector } from "react-redux";
import AboutUsSection from "../../components/about/AboutUS";
import Arch from "../../assest/Team-Logo.png";
import { Link } from "react-router-dom";
import Tick from "../../assest/check.png";
import {
  FaBriefcase,
  FaClock,
  FaFolderOpen,
  FaChartLine,
  FaGraduationCap,
  FaMoneyBillWave,
  FaMapMarkerAlt,
} from "react-icons/fa";

const JobDetails = () => {
  const { language } = useSelector((state) => state.language);
  
  // Translation dictionary
  const translations = {
    gb: {
      // English
      heading: "Job Details",
      buttonText: "Get In Touch",
      jobTitle: "Team Lead Manager",
      jobDescription: [
        "Etihad Gharbia Contracting Company is a leading provider of comprehensive contracting and construction services, specializing in Contracting, Manpower Supply, Equipment Rental, and Transportation.",
        "We deliver innovative solutions, exceptional quality, and unmatched value. From concept to completion, we are dedicated to exceeding client expectations.",
        "Trusted by Saudi Technic, Saudi Arabia Railways, Ministry of Health, and more, we proudly serve the KSA market with high-quality equipment, skilled manpower, and efficient services."
      ],
      keyResponsibilitiesTitle: "Key Responsibilities",
      keyResponsibilities: [
        "Deliver comprehensive contracting and construction services across KSA.",
        "Ensure integrity, professionalism, and customer satisfaction in every project.",
        "Maintain strong relationships with clients such as Saudi Technic, Ministry of Health, and more.",
        "Coordinate manpower, equipment rental, and transport logistics efficiently.",
        "Oversee project execution from concept to completion, ensuring high quality and value.",
      ],
      professionalSkillsTitle: "Professional Skills",
      professionalSkills: [
        "Expertise in heavy equipment rental and site logistics.",
        "Proficient in managing large-scale manpower supply and coordination.",
        "Strong understanding of IT & GPS solutions for field operations.",
        "Experience with government and private sector contracting.",
        "Skilled in project planning, safety protocols, and client communication.",
      ],
      applyJob: "Apply Job",
      jobOverviewTitle: "Job Overview",
      jobOverview: [
        { label: "Job Title", value: "Corporate Solutions Executive" },
        { label: "Job Type", value: "Full Time" },
        { label: "Category", value: "Commerce" },
        { label: "Experience", value: "5 Years" },
        { label: "Degree", value: "Master" },
        { label: "Offered Salary", value: "$40000–$42000" },
        { label: "Location", value: "New York, USA" },
      ]
    },
    sa: {
      // Arabic
      heading: "تفاصيل الوظيفة",
      buttonText: "تواصل معنا",
      jobTitle: "مدير فريق العمل",
      jobDescription: [
        "شركة اتحاد غربيا للمقاولات هي مزود رائد لخدمات المقاولات والبناء الشاملة، متخصصة في المقاولات وتوريد العمالة وتأجير المعدات والنقل.",
        "نقدم حلولًا مبتكرة وجودة استثنائية وقيمة لا مثيل لها. من المفهوم إلى الإنجاز، نحن ملتزمون بتجاوز توقعات العملاء.",
        "موثوق به من قبل السعودية للتقنية وسكك الحديد السعودية ووزارة الصحة وغيرها، نخدم بسوق المملكة العربية السعودية بمعدات عالية الجودة وعمالة ماهرة وخدمات فعالة."
      ],
      keyResponsibilitiesTitle: "المسؤوليات الرئيسية",
      keyResponsibilities: [
        "تقديم خدمات المقاولات والبناء الشاملة في جميع أنحاء المملكة العربية السعودية.",
        "ضمان النزاهة والاحترافية ورضا العملاء في كل مشروع.",
        "الحفاظ على علاقات قوية مع عملاء مثل السعودية للتقنية ووزارة الصحة وغيرها.",
        "تنسيق العمالة وتأجير المعدات والخدمات اللوجستية للنقل بكفاءة.",
        "الإشراف على تنفيذ المشروع من المفهوم إلى الإنجاز، مع ضمان الجودة العالية والقيمة المضافة.",
      ],
      professionalSkillsTitle: "المهارات المهنية",
      professionalSkills: [
        "خبرة في تأجير المعدات الثقيلة والخدمات اللوجستية للموقع.",
        "كفاءة في إدارة توريد العمالة واسعة النطاق والتنسيق.",
        "فهم قوي لحلول تكنولوجيا المعلومات ونظام تحديد المواقع العالمية للعمليات الميدانية.",
        "خبرة في التعاقد مع القطاع الحكومي والخاص.",
        "مهارة في تخطيط المشاريع وبروتوكولات السلامة والتواصل مع العملاء.",
      ],
      applyJob: "تقدم للوظيفة",
      jobOverviewTitle: "نظرة عامة على الوظيفة",
      jobOverview: [
        { label: "المسمى الوظيفي", value: "مدير الحلول المؤسسية" },
        { label: "نوع الوظيفة", value: "دوام كامل" },
        { label: "الفئة", value: "تجارة" },
        { label: "الخبرة", value: "5 سنوات" },
        { label: "الدرجة العلمية", value: "ماجستير" },
        { label: "الراتب المقدم", value: "40000–42000 $" },
        { label: "الموقع", value: "نيويورك، الولايات المتحدة" },
      ]
    },
    fr: {
      // French
      heading: "Détails de l'emploi",
      buttonText: "Contactez-nous",
      jobTitle: "Chef d'équipe Manager",
      jobDescription: [
        "Etihad Gharbia Contracting Company est un fournisseur leader de services complets de contrat et de construction, spécialisé dans les Contrats, la Fourniture de Main-d'œuvre, la Location d'Équipement et le Transport.",
        "Nous offrons des solutions innovantes, une qualité exceptionnelle et une valeur inégalée. Du concept à la réalisation, nous nous engageons à dépasser les attentes des clients.",
        "Forte de la confiance de Saudi Technic, Saudi Arabia Railways, Ministry of Health et d'autres, nous servons fièrement le marché de l'Arabie Saoudite avec des équipements de haute qualité, une main-d'œuvre qualifiée et des services efficaces."
      ],
      keyResponsibilitiesTitle: "Responsabilités clés",
      keyResponsibilities: [
        "Fournir des services complets de contrat et de construction à travers l'Arabie Saoudite.",
        "Assurer l'intégrité, le professionnalisme et la satisfaction du client dans chaque projet.",
        "Maintenir des relations solides avec des clients tels que Saudi Technic, Ministry of Health et d'autres.",
        "Coordonner efficacement la main-d'œuvre, la location d'équipement et la logistique de transport.",
        "Superviser l'exécution du projet du concept à la réalisation, en garantissant qualité et valeur.",
      ],
      professionalSkillsTitle: "Compétences professionnelles",
      professionalSkills: [
        "Expertise en location d'équipement lourd et logistique de site.",
        "Compétence dans la gestion de la fourniture et la coordination de main-d'œuvre à grande échelle.",
        "Bonne compréhension des solutions informatiques et GPS pour les opérations sur le terrain.",
        "Expérience dans les contrats avec les secteurs public et privé.",
        "Compétences en planification de projet, protocoles de sécurité et communication client.",
      ],
      applyJob: "Postuler",
      jobOverviewTitle: "Aperçu de l'emploi",
      jobOverview: [
        { label: "Titre du poste", value: "Responsable des Solutions d'Entreprise" },
        { label: "Type d'emploi", value: "Temps plein" },
        { label: "Catégorie", value: "Commerce" },
        { label: "Expérience", value: "5 ans" },
        { label: "Diplôme", value: "Master" },
        { label: "Salaire proposé", value: "40000–42000 $" },
        { label: "Lieu", value: "New York, USA" },
      ]
    },
    de: {
      // German
      heading: "Stellenbeschreibung",
      buttonText: "Kontakt aufnehmen",
      jobTitle: "Teamleiter Manager",
      jobDescription: [
        "Etihad Gharbia Contracting Company ist ein führender Anbieter von umfassenden Vertrags- und Bauleistungen, spezialisiert auf Vertragsarbeiten, Arbeitskräftebereitstellung, Gerätemiete und Transport.",
        "Wir liefern innovative Lösungen, außergewöhnliche Qualität und unübertroffenen Wert. Vom Konzept bis zur Fertigstellung sind wir bestrebt, die Erwartungen unserer Kunden zu übertreffen.",
        "Vertrauenswürdig für Saudi Technic, Saudi Arabia Railways, Ministry of Health und mehr, bedienen wir stolz den KSA-Markt mit hochwertigen Geräten, qualifizierten Arbeitskräften und effizienten Dienstleistungen."
      ],
      keyResponsibilitiesTitle: "Schlüsselverantwortlichkeiten",
      keyResponsibilities: [
        "Umfassende Vertrags- und Bauleistungen in ganz Saudi-Arabien erbringen.",
        "Integrität, Professionalität und Kundenzufriedenheit in jedem Projekt sicherstellen.",
        "Pflege starker Beziehungen zu Kunden wie Saudi Technic, Ministry of Health und mehr.",
        "Effiziente Koordination von Arbeitskräften, Gerätemiete und Transportlogistik.",
        "Überwachung der Projektausführung von der Konzeption bis zur Fertigstellung unter Gewährleistung von Qualität und Wert.",
      ],
      professionalSkillsTitle: "Berufliche Fähigkeiten",
      professionalSkills: [
        "Expertise in der Vermietung schwerer Geräte und Standortlogistik.",
        "Erfahrung in der Verwaltung der Bereitstellung und Koordination von Arbeitskräften in großem Maßstab.",
        "Starkes Verständnis von IT- und GPS-Lösungen für Feldoperationen.",
        "Erfahrung mit Verträgen im öffentlichen und privaten Sektor.",
        "Fähigkeiten in Projektplanung, Sicherheitsprotokollen und Kundenkommunikation.",
      ],
      applyJob: "Bewerben",
      jobOverviewTitle: "Stellenübersicht",
      jobOverview: [
        { label: "Stellenbezeichnung", value: "Corporate Solutions Executive" },
        { label: "Anstellungsart", value: "Vollzeit" },
        { label: "Kategorie", value: "Handel" },
        { label: "Erfahrung", value: "5 Jahre" },
        { label: "Abschluss", value: "Master" },
        { label: "Gehaltsangebot", value: "40000–42000 $" },
        { label: "Standort", value: "New York, USA" },
      ]
    }
  };

  // Get current translations based on language
  const t = translations[language] || translations.gb;

  const jobOverview = [
    { label: t.jobOverview[0].label, value: t.jobOverview[0].value, icon: <FaBriefcase /> },
    { label: t.jobOverview[1].label, value: t.jobOverview[1].value, icon: <FaClock /> },
    { label: t.jobOverview[2].label, value: t.jobOverview[2].value, icon: <FaFolderOpen /> },
    { label: t.jobOverview[3].label, value: t.jobOverview[3].value, icon: <FaChartLine /> },
    { label: t.jobOverview[4].label, value: t.jobOverview[4].value, icon: <FaGraduationCap /> },
    { label: t.jobOverview[5].label, value: t.jobOverview[5].value, icon: <FaMoneyBillWave /> },
    { label: t.jobOverview[6].label, value: t.jobOverview[6].value, icon: <FaMapMarkerAlt /> },
  ];

  return (
    <>
      <AboutUsSection heading={t.heading} buttonText={t.buttonText} />

      <section className="py-5 bg-white">
        <div className="container">
          <div className="row gy-5">
            {/* Left Content */}
            <div className="col-lg-8">
              <div className="d-flex align-items-center mb-4 gap-3">
                <img
                  src={Arch}
                  alt="Company Logo"
                  className="img-fluid"
                  style={{ width: "50px", height: "50px" }}
                />
                <h1 className="h2 fw-bold text-dark m-0">{t.jobTitle}</h1>
              </div>

              <div className="mb-4">
                <h3 className="h5 mb-3 text-dark">Job Description</h3>
                {t.jobDescription.map((paragraph, idx) => (
                  <p key={idx}>{paragraph}</p>
                ))}
              </div>

              <div className="mb-4">
                <h3 className="h5 mb-3 text-dark">{t.keyResponsibilitiesTitle}</h3>
                <ul className="list-unstyled">
                  {t.keyResponsibilities.map((item, idx) => (
                    <li key={idx} className="d-flex align-items-start mb-2">
                      <img
                        src={Tick}
                        alt="Tick"
                        className="me-2 mt-1"
                        style={{ width: "16px", height: "16px" }}
                      />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="mb-4">
                <h3 className="h5 mb-3 text-dark">{t.professionalSkillsTitle}</h3>
                <ul className="list-unstyled">
                  {t.professionalSkills.map((item, idx) => (
                    <li key={idx} className="d-flex align-items-start mb-2">
                      <img
                        src={Tick}
                        alt="Tick"
                        className="me-2 mt-1"
                        style={{ width: "16px", height: "16px" }}
                      />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Sidebar */}
            <div className="col-lg-4">
              <Link to="/job-info" className="w-140 rounded-pill">
                <button className="btn btn-danger w-70 rounded-pill mb-4 fw-semibold">
                  {t.applyJob}
                </button>
              </Link>

              <div className="card mb-4">
                <div className="card-body">
                  <h4 className="h6 text-dark mb-3">{t.jobOverviewTitle}</h4>
                  <ul className="list-unstyled">
                    {jobOverview.map((item, idx) => (
                      <li key={idx} className="d-flex align-items-start mb-2">
                        <span className="text-danger me-2 mt-1">
                          {item.icon}
                        </span>
                        <span>
                          <strong>{item.label}:</strong> {item.value}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <div className="card">
                <div className="card-body p-2">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d24178.93944053246!2d-74.00944725!3d40.7127753!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDQyJzQ2LjAiTiA3NMKwMDAnMjIuMCJX!5e0!3m2!1sen!2sus!4v1660000000000!5m2!1sen!2sus"
                    width="100%"
                    height="200"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Map Location"
                    className="rounded"
                  ></iframe>
                </div>
              </div>
            </div>
            {/* End Sidebar */}
          </div>
        </div>
      </section>
    </>
  );
};

export default JobDetails;